import { render, staticRenderFns } from "./PurchaseDuoItemProvisionList.vue?vue&type=template&id=7d84fb9a&"
import script from "./PurchaseDuoItemProvisionList.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoItemProvisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports